(function($) {

	function get_slider_data( $arr ) {

		var values  = [],
			rangers = [],
			data    = {};

		for (i = 0; i < $arr.length; ++i) {
			rangers.push($arr[i].value);
			values[ $arr[i].value ] = $arr[i].label;
		}

		data.values = values;
		data.range  = rangers;

		return data;
	}


	/**
	 * Get datacenter slide
	 */
	function get_datacenter( $post_id ) {

		$.ajax({
			url: cc.ajax_url,
			data: {
				nonce: cc.nonce,
				action: 'do_get_datacenter',
				post_id: Math.abs($post_id),
			},
			type: 'post',
			dataType: 'json',
			success: function( data, textStatus, XMLHttpRequest ) {

				html = $.parseHTML( data );
				$('.datacenter-preview').html(html);
				/*console.log( data );
				console.log( XMLHttpRequest );*/
			},
			error: function( MLHttpRequest, textStatus, errorThrown ) {

				/*console.log( MLHttpRequest );
				console.log( textStatus );
				console.log( errorThrown );*/
			}
		});
	}


	$('[data-toggle="offcanvas"]').click( function () {
		$('body').toggleClass('nav-active');
		$('.sidebar-offcanvas').css('top', $(window).scrollTop() );
	});


	$('.nav-offcanvas a').not(':only-child').click( function (event) {
		if(event.preventDefault) { event.preventDefault(); }
		$(this).parent('li').toggleClass('open');
	});

	$(document).ready(function() {

		/**
		 * Scroll to section
		 */
		$('a[data-scrollto]').click( function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			$target  = $(this).data('scrollto');
			$section = $('#' + $target);

			if ( $section.length ) {
				$('html,body').animate({
					scrollTop: $section.offset().top - $('.banner').height()
				}, 600);
			}
			else {
				window.location.href = $(this).attr('href') + '#!' + $target;
			}
		});

		hashScroll = location.hash.substr(2);
		$section   = $('#' + hashScroll);

		if ( $section.length ) {
			$('html,body').animate({
				scrollTop: $section.offset().top - $('.banner').height()
			}, 600);
		}

		/**
		 * IE SVG Fix
		 */
		svg4everybody();

		/**
		 * Disabele zoom on mobile
		 */
		document.addEventListener('gesturestart', function(e){ e.preventDefault(); });

		/**
		 * Coverflow
		 */

		$carousel = $('#coverflow');

		if ( $carousel.length ) {

			$carousel.flipster({
				itemContainer: 'ul',
				itemSelector: 'li',
				start: 'center',
				fadeIn: 400,
				loop: true,
				autoplay: false,
				pauseOnHover: true,
				style: 'flat',
				spacing: -0.5,
				click: true,
				keyboard: true,
				scrollwheel: false,
				touch: true,
				nav: 'after',
				buttons: true,
				buttonPrev: 'Previous',
				buttonNext: 'Next',
				onItemSwitch: false
			});
		}

		/**
		 * Matchheights
		 */
		if ( $(window).width() > 991 ) {

			$('.wgt-home-intro h3').matchHeight();
			$('.wgt-home-intro  .entry-summary').matchHeight();
		}

		$('.wgt-services-packs h3').matchHeight();
		$('.wgt-services-managed .entry-summary').matchHeight();
		$('.wgt-benefits-columns h3').matchHeight();
		$('.wgt-benefits-columns .entry-summary').matchHeight();


		/**
		 * Locations Tabs
		 */

		$('.nav-tabs a').click( function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			$tabbed = $(this).closest('.tabbed');

			$tabbed.find('.active').removeClass('active');
			$tabbed.find( $(this).attr('href') ).addClass('active');

			$(this).parent('li').addClass('active');
		});

		/**
		 * Locations Accordion
		 */
		$('.main').on( 'click', '.accordion a', function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			$accordion = $(this).closest('.accordion');

			$accordion.find('.active').removeClass('active');
			$(this).parent('li').addClass('active');
		});

		/**
		 * Server Customizer
		 */
		var sliders = document.getElementsByClassName('slider');

		function customizerSlide( data ) {
			rack   = $('.rack');
			input  = $(data.input[0]);
			label  = input.parent('.slide-wrap').next('.label-right');
			target = input.data('target');

			json   = $.parseJSON( input.next('input').val() );
			json   = get_slider_data(json);
			value  = json.values[data.from_value];

			if ( target === 'unit' && rack.length ) {

				rack.find('li').removeClass('active');
				e = rack.find('li').slice(-Math.abs(data.from_value));
				e.addClass('active');
			}
			else if ( target !== '' ) {
				$('.' + target).html(value);
			}

			label.html(value);
		}

		for ( var i = 0; i < sliders.length; i++ ) {

			json = $(sliders[i]).next('input').val();
			json = $.parseJSON(json);
			json = get_slider_data(json);

			$(sliders[i]).ionRangeSlider({
				type: 'single',
				from: 1,
				values: json.range,
				onChange: customizerSlide(data)
			});
		}


		/**
		 * Datacenters mobile select
		 */
		$('.toggle-datacenters').click(function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			$('.datacenters-select-wrap').toggleClass('open');
		});

		$('.datacenters-select a').click(function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			$('.datacenters-select .active').removeClass('active');
			$(this).parent('li').addClass('active');

			$('.datacenters-select-wrap').toggleClass('open');

			// Retrieve Datacenter
			get_datacenter( $(this).data('item') );
		});

		$('.type-3 .datacenter-map a').click( function(event) {
			if(event.preventDefault) { event.preventDefault(); }

			// Retrieve Datacenter
			get_datacenter( $(this).data('item') );
		});
	});

})(jQuery);